import type { NonLCCApproversListResponse } from './api';

export const normalizeNonLCCApproversList = (list: NonLCCApproversListResponse): { label: string; value: number }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.name,
    value: row.userId,
  }));
};
